import React, { useEffect, useState } from 'react'
import styles from './ShopOrdersList.module.scss'
import { getShopOrders } from '../../../service/ShopService'
import Loader from '../../../components/Loader/Loader'

// iOS-safe: handles "DD.MM.YYYY HH:MM" and ISO strings
const parseOrderDate = (raw) => {
  if (!raw) return ''
  let d
  const m = String(raw).match(/^(\d{2})\.(\d{2})\.(\d{4})(?:[\s T](\d{2}):(\d{2}))?/)
  if (m) {
    d = new Date(`${m[3]}-${m[2]}-${m[1]}T${m[4] || '00'}:${m[5] || '00'}:00`)
  } else {
    d = new Date(String(raw).replace(' ', 'T'))
  }
  if (isNaN(d)) return raw
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit', month: 'long', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  })
}

const ShopOrdersList = () => {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadOrders()
  }, [])

  const loadOrders = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await getShopOrders()
      setOrders(response.data.results || response.data || [])
    } catch (err) {
      setError('Ошибка загрузки заказов')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const getStatusText = (status) => {
    const statuses = {
      created: 'Создан',
      paid: 'Оплачен',
      processing: 'В обработке',
      shipped: 'Отправлен',
      delivered: 'Доставлен',
      completed: 'Завершен',
      cancelled: 'Отменен',
    }
    return statuses[status] || status
  }

  const getStatusColor = (status) => {
    const colors = {
      created: '#FFA500',
      paid: '#4CAF50',
      processing: '#2196F3',
      shipped: '#9C27B0',
      delivered: '#00BCD4',
      completed: '#4CAF50',
      cancelled: '#F44336',
    }
    return colors[status] || '#666'
  }

  if (loading) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    )
  }

  if (error) {
    return (
      <div className={styles.error}>
        <p>{error}</p>
        <button onClick={loadOrders}>Повторить</button>
      </div>
    )
  }

  if (orders.length === 0) {
    return (
      <div className={styles.empty}>
        <div className={styles.emptyIcon}>📦</div>
        <h3>У вас пока нет заказов</h3>
        <p>Оформите заказ в магазине, и он появится здесь</p>
      </div>
    )
  }

  return (
    <div className={styles.ordersList}>
      {orders.map((order) => (
        <div key={order.id} className={styles.orderCard}>
          <div className={styles.orderHeader}>
            <div className={styles.orderInfo}>
              <h3>Заказ #{order.id}</h3>
              <span className={styles.orderDate}>
                {parseOrderDate(order.created_at)}
              </span>
            </div>
            <div 
              className={styles.orderStatus}
              style={{ backgroundColor: getStatusColor(order.status) }}
            >
              {getStatusText(order.status)}
            </div>
          </div>

          <div className={styles.orderItems}>
            {order.items && order.items.map((item) => (
              <div key={item.id} className={styles.orderItem}>
                <div className={styles.itemImage}>
                  <img 
                    src={item.product?.main_image || item.product?.image || '/placeholder-product.jpg'} 
                    alt={item.product?.name}
                  />
                </div>
                <div className={styles.itemInfo}>
                  <h4>{item.product?.name}</h4>
                  <p>{item.quantity} шт. × {item.unit_price} сом</p>
                </div>
                <div className={styles.itemTotal}>
                  {(item.quantity * item.unit_price).toFixed(2)} сом
                </div>
              </div>
            ))}
          </div>

          {order.notes && (
            <div className={styles.orderNotes}>
              <strong>Примечание:</strong> {order.notes}
            </div>
          )}

          <div className={styles.orderFooter}>
            <div className={styles.orderTotal}>
              <span>Итого:</span>
              <strong>{order.total_amount} сом</strong>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ShopOrdersList
